import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent2: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Choose your beachhead market</h3>
            <span className="text-muted fs-7">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    How to select your beachhead market
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <p className="fs-7">Selecting your beachhead market is critical for narrowing focus and attention to only one area of attack. Entrepreneurs have limited resources and must be very careful how these are deployed.</p>

                    <p className="fs-7">To have maximum impact, put all resources into one market and deselect the other markets for now. This is sometimes called “putting all the wood behind the arrow”. This concept is well described as well in Geoffrey Moore’s class “Crossing the Chasm” book. Especially for first-time entrepreneurs, who find it very difficult to ignore market opportunities, and who are hoping that chasing more markets will lead to one taking off sooner or later, the process of focusing on one to the exclusions of others is very painful. Suck it up and do it. Strongly focus on one and the others will come later.</p>

                    <p className="fs-7">Focusing now on more than one segment = Increasing odds of failure.</p>

                    <p className="fs-7">Focusing now on one segment = Increasing odds of success.</p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Choosing a Beachhead market
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  <p className="fs-7">Use the criteria below to narrow your market opportunities and to select a beachhead market. Ask these questions for each market segment that you've identified in Step 1. Note, there is every likelihood of more than one market you could be successful in immediately, so don’t feel there is one singular right answer. Pick one and move on! Deciding whether or not there is one right answer (fear of being wrong) gets you stuck in “analysis paralysis” instead of getting you involved in the primary goal: testing beliefs through action and primarymarket research.</p>

                  <p className="fs-7">In fact, it is critical that the dominant fraction of the data you get to make this (and the other decisions) comes from primary market research. The answer resides with the data from the direct interaction with real potential customers and not by debates that you have in your office free of primary market research data analysis. Remember too, that as much as you might love your idea, you are in inquiry mode and not advocacy (i.e., selling) mode now.</p>

                  <p className="fs-7">Also note that if you make an educated guess on a beachhead market and you then invalidate it, that could be a good thing, because now you can focus on the other options and not look back again at the first market.</p>

                  <p className="fs-7">Lively team discussions will help you select your best beachhead market (first market) to approach. Discuss these:</p>

                  <ol>
                    <li className="fs-7">Is the target customer well-funded?</li>
                    <li className="fs-7">Can your sales force readily access the target customer?</li>
                    <li className="fs-7">Does the target customer have a compelling reason to buy?</li>
                    <li className="fs-7">Can you today, with the help of partners, deliver a whole product? – i.e., a 100% of the solution?</li>
                    <li className="fs-7">Is there real or perceived entrenched competition (from the target customer's perspective) that could block you?</li>
                    <li className="fs-7">If you win this segment, can you leverage it to enter additional segments?</li>
                    <li className="fs-7">Is this market consistent with the values, passions and goals of your founding team?</li>
                    </ol>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_3">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_3"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_3"
                  >
                    Is your market targeted enough?
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_3"
                  className="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_3"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                    <p className="fs-7">In order to be able to focus and successfully chase the opportunity, you have to make sure that the market is well-targeted. If the market is not homogenous, segment it further, until you can focus on a segment which fits all the criteria below.</p>

                    <p className="fs-7">The customers within the market all buy similar products.
                  The customers within the market have a similar sales process. They also expect products to provide value in similar ways and they are sold in a similar manner. For instance, they have a similar value proposition and persona.
                  There is "word of mouth" between customers in the market, which can serve as compelling reference to other customers.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>

  );
};

export { StepContent2 };
